import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-price-chart-picker',
  templateUrl: './price-chart-picker.component.html',
  styleUrls: ['./price-chart-picker.component.css']
})
export class PriceChartPickerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// c:/WebProjects/angularcoin/src/app/component/price-chart-picker/price-chart-picker.component.ts